


export default function Market() {
  return (
    <div>
        <h1 style={{color: "#aaa"}}>Comming soon...</h1>
    </div>
  )
}
